export default __webpack_public_path__ + "static/comparisons-team--mobile-011f905e4739f9fdf88d14fb46dfdd7c.jpg";